module.exports = __webpack_public_path__ + "static/media/YF18_5.d72194aa.jpg";